import { AfterViewInit, Component, OnInit, ViewChild } from '@angular/core';
import { MatDialog, MatPaginator, MatTableDataSource } from '@angular/material';
import { MatSnackBar } from '@angular/material/snack-bar';
import { UserPermGroupDialogComponent } from 'app/components/dialog/user-perm-group-dialog/user-perm-group-dialog.component';
import { ClienteMinModel } from 'app/model/cliente/clienteMin.model';
import { GrupoPermissionModel } from 'app/model/permission/grupopermission.model';
import { RelatorioService } from 'app/service/cliente/relatorio.service';
import { PermissionsService } from 'app/service/permission/permissions.service';

import { UsuarioRM } from './../model/usuario/usuarioRM.model';

@Component({
  selector: 'app-listagem-permissoes',
  templateUrl: './listagem-permissoes.component.html',
  styleUrls: ['./listagem-permissoes.component.scss'],
})
export class ListagemPermissoesComponent implements OnInit, AfterViewInit {
  @ViewChild(MatPaginator) usersPaginator: MatPaginator;

  loading = true;
  usuarios: UsuarioRM[] = [];
  totalUsers = 0;

  displayedColumns = ['id', 'name', 'username', 'active', 'action'];

  clients: ClienteMinModel[] = [];
  clientSelected: any = -1;
  permGroups: GrupoPermissionModel[] = [];
  groupSelected: any = -1;
  dataSourceUsers: MatTableDataSource<UsuarioRM> = new MatTableDataSource([]);

  constructor(
    private permissionsService: PermissionsService,
    private _snackBar: MatSnackBar,
    public dialog: MatDialog,
    private relatorioService: RelatorioService
  ) {}

  ngOnInit() {
    this.getAllUsers();
    this.getAllClients();
    this.listPermGroups();
  }

  ngAfterViewInit() {
    this.dataSourceUsers.paginator = this.usersPaginator;
  }

  listUsersByClientPermissionGroup() {
    this.loading = true;
    this.permissionsService
      .getUsersByClientPermissionGroup(
        this.clientSelected.id,
        this.groupSelected.id
      )
      .subscribe(
        (data) => {
          this.loading = false;
          this.usuarios = data;
          if (data.length === 0) {
            this.openSnackBar(
              'Esta empresa não possui usuários vinculados a este grupo',
              true
            );
          }
          this.dataSourceUsers.data = data;
        },
        (err) => {
          this.handleError(
            err,
            'Ocorreu um erro ao buscar Usuários, tente novamente em alguns instantes'
          );
        }
      );
  }

  listUsersByClient() {
    this.loading = true;
    this.relatorioService
      .getUsuariosPorCliente(this.clientSelected.id)
      .subscribe(
        (data) => {
          if (data.length === 0) {
            this.openSnackBar(
              'Esta empresa não possui usuários vinculados',
              true
            );
            this.dataSourceUsers.data = [];
          } else {
            this.usuarios = data.map((u) => ({
              id: u.id,
              nome: u.nome,
              userId: u.userId,
              enabled: u.enabled,
            }));
            this.dataSourceUsers.data = this.usuarios;
          }
          this.loading = false;
        },
        (err) => {
          this.handleError(
            err,
            'Ocorreu um erro ao buscar Usuários, tente novamente em alguns instantes'
          );
        }
      );
  }

  applyFilter(filterValue: string) {
    filterValue = filterValue.trim();
    filterValue = filterValue.toLowerCase();
    this.dataSourceUsers.filter = filterValue;
  }

  getAllClients() {
    this.permissionsService.getAllClientsMin().subscribe(
      (data: Array<ClienteMinModel>) => {
        this.clients = data;
      },
      (err) => {
        this.handleError(err, 'Ocorreu um erro ao buscar Empresas!');
      }
    );
  }

  listPermGroups() {
    this.permissionsService.getAllGrupos().subscribe(
      (data: Array<GrupoPermissionModel>) => {
        this.loading = false;
        this.permGroups = data;
      },
      (err) => {
        this.handleError(
          err,
          'Ocorreu um erro ao buscar Grupos de permissões!'
        );
      }
    );
  }

  vincularUser() {
    const dialogRef = this.dialog.open(UserPermGroupDialogComponent, {
      width: '100%',
      maxHeight: '95vh',
      data: {
        client: this.clientSelected,
        group: this.groupSelected,
      },
    });
    dialogRef.afterClosed().subscribe(
      (result) => {
        if (result) {
          this.listUsersByClientPermissionGroup();
        }
      },
      (err) => {
        this.handleError(
          err,
          'Ocorreu um erro, tente novamente em alguns instantes'
        );
      }
    );
  }

  onSearch() {
    if (this.clientSelected === -1) {
      this.getAllUsers();
    } else if (this.groupSelected === -1) {
      this.listUsersByClient();
    } else {
      this.listUsersByClientPermissionGroup();
    }
  }

  getAllUsers() {
    this.loading = true;
    this.permissionsService.getUsuariosRM(0, 1000).subscribe(
      (data) => {
        this.loading = false;
        this.usuarios = data.content;
        if (data.totalElements === 0) {
          this.openSnackBar('Não há usuários salvos no RM', true);
        }
        this.dataSourceUsers.data = this.usuarios;
        this.dataSourceUsers.paginator = this.usersPaginator;
      },
      (err) => {
        this.handleError(err, 'Ocorreu um erro ao buscar todos os usuários');
      }
    );
  }

  handleError(err: Error, msg: string) {
    console.error(err);
    this.loading = false;
    this.openSnackBar(msg, true);
  }

  openSnackBar(message: string, isErr: boolean) {
    this._snackBar.open(message, '', {
      horizontalPosition: 'right',
      verticalPosition: 'top',
      duration: 3000,
      panelClass: isErr ? ['error-snackbar'] : ['success-snackbar'],
    });
  }
}



// WEBPACK FOOTER //
// /app/src/app/listagem-permissoes/listagem-permissoes.component.ts